import React, { SVGProps } from 'react';

const SvgCustomToggleButtonClose = (props: SVGProps<SVGSVGElement>) => (
    <svg  
        xmlSpace='preserve'  
        width="26" height="27" 
        viewBox="0 0 26 27" 
        fill="none" 
        className='svg-icon'  {...props} 
        xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1.60986" width="24" height="24" rx="6.92375" stroke="#4B4B4B" strokeOpacity="0.8" strokeWidth="1.94595"/>
    <path d="M12.1426 8.4668L6.99972 13.6097L12.1426 18.7525" stroke="#4B4B4B" strokeWidth="1.94595"/>
    <path d="M19 8.4668L13.8571 13.6097L19 18.7525" stroke="#4B4B4B" strokeWidth="1.94595"/>
    </svg>


);

export default SvgCustomToggleButtonClose;